import { createSlice } from '@reduxjs/toolkit';

export const adminUISlice = createSlice({
    name: 'adminUI',
    initialState: {
        toast: { show: false, title: '', message: '', variant: '' }
    },
    reducers: {
        showMessage: (state, action) => {
            state.toast = {
                show: true,
                variant: action.payload.variant,
                title: action.payload.title,
                message: action.payload.message
            }
        },
        clearMessage: (state) => {
            state.toast = {
                show: false,
                title: '',
                message: '',
                variant: ''
            }
        }
    }
});
export const { showMessage, clearMessage } = adminUISlice.actions;
export default adminUISlice.reducer;